function NotFound() {
	return (
		<div className="flex w-full h-full items-center justify-center">
			Page not found
		</div>
	);
}

export default NotFound;
